import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const UpdateNotificationStatus = async (notificationId) => {
  try {
    await updateDoc(doc(db, "notifications", notificationId), {
      is_seen: true,
    });
  } catch (error) {
    console.log(error);
    return "";
  }
};

export default UpdateNotificationStatus;
